module.exports = __webpack_public_path__ + "static/media/tipSearch.3f26aaaf.png";